import React from 'react';
import clsx from 'clsx';
import { Flex, FlexProps } from '@common/components';
import { Spacing, SpacingTokenType } from '@common/tokens';

/**
 * The Gap component is just an extension of the Flex component adding the gap behavior beyond
 * the regular flex behavior. That's why it inherits all the props from the Flex component.
 */
export const Gap = ({
  className,
  children,
  size = 'sm',
  ...props
}: FlexProps & {
  size?: SpacingTokenType;
}) => {
  return (
    <>
      <Flex {...props} className={clsx('wk-gap', `wk-gap--${size}`, className)}>
        {children}
      </Flex>
      <style jsx>{`
        :global(.wk-gap.wk-gap--xxs) {
          gap: ${Spacing.xxs}px;
        }
        :global(.wk-gap.wk-gap--xs) {
          gap: ${Spacing.xs}px;
        }
        :global(.wk-gap.wk-gap--sm) {
          gap: ${Spacing.sm}px;
        }
        :global(.wk-gap.wk-gap--md) {
          gap: ${Spacing.md}px;
        }
        :global(.wk-gap.wk-gap--lg) {
          gap: ${Spacing.lg}px;
        }
        :global(.wk-gap.wk-gap--xl) {
          gap: ${Spacing.xl}px;
        }
        :global(.wk-gap.wk-gap--xxl) {
          gap: ${Spacing.xxl}px;
        }
        :global(.wk-gap.wk-gap--xxxl) {
          gap: ${Spacing.xxxl}px;
        }
      `}</style>
    </>
  );
};
